export function Chip({ onClick, text, active = false, actionable = true }) {
  return actionable ? (
    <button
      onClick={onClick}
      className={`block rounded-xxxs px-8 py-6 media-hover:hover:cursor-pointer ${
        active
          ? "bg-gray-700 text-white border border-solid border-gray-700"
          : "bg-gray-100 text-gray-900 border border-solid border-gray-300 media-hover:hover:bg-gray-700 media-hover:hover:text-white media-hover:hover:border-transparent duration-300"
      }`}
      aria-label={text || ""}
    >
      {text && <span className="text-xxs font-medium">{text}</span>}
    </button>
  ) : (
    <div className="block rounded-xxxs px-8 py-6 bg-gray-100 text-gray-900 border border-solid border-gray-300">
      {text && <span className="text-xxs font-medium">{text}</span>}
    </div>
  );
}

export function ChipSearch({ text, href, count }) {
  return (
    <a
      href={href}
      className="flex items-center gap-x-4 rounded-xxxs px-8 py-6 bg-gray-200 text-gray-900 media-hover:hover:bg-gray-300 duration-300 whitespace-nowrap"
    >
      {text && (
        <span className="text-xxs font-medium leading-115 tracking-05">
          {text}
        </span>
      )}
      <div className="flex px-6 h-[18px] bg-gray-700 rounded-full">
        <span className="my-auto text-gray-100 text-xxxs font-medium tracking-05">
          {count}
        </span>
      </div>
    </a>
  );
}

export function ChipTalktoExpert({ onClick, text, active = false }) {
  return (
    <button
      onClick={onClick}
      className={`block rounded-xxxs px-8 py-6 media-hover:hover:cursor-pointer media-hover:hover:bg-white duration-300 ${
        active ? "bg-white text-gray-90" : "bg-white/50"
      }`}
      aria-label={text || ""}
    >
      {text && <span className="text-xxxs font-medium">{text}</span>}
    </button>
  );
}
